import {SortDirection} from "../../../../../data-structures/sort"
import {CardViewLayout} from "../../../../../gd-ui/card-view-selector/card-view-selector"
import {SystemColumnType} from "../../../../manager/columns/types"
import {SettingsVersion} from "../../../../common/settings-manager"
import {SystemStatusGroup} from "../../../../../gd/const/system-status"
import {GroupingType} from "../../../../../gd/manager/group-by/@types"

export const TasksView_List_SettingsDefault = {
    version                 : SettingsVersion.VERSION_3,

    // columns:            _.map(['2','12','4','3','6'], id=>({id: id/*, aggregate: null*/})),
    columns                 : [
        {
            id      : SystemColumnType.TITLE
        },
        {
            id      : SystemColumnType.ACTION_REQUIRED
        },
        {
            id      : SystemColumnType.SCHEDULE
        },
        {
            id      : SystemColumnType.PRIORITY
        },
        {
            id      : SystemColumnType.STATUS
        },
    ],
    systemStatusFilter      : SystemStatusGroup.ALL, // used is task list to show hide archived tasks
    showSubfolders          :     true,
    /*groupBy1:         {
        fieldId         : undefined,
        sortDirection   : SortDirection.ASC,
        params          : {}
    },
    groupBy2:         {
        fieldId         : 'statusId',
        sortDirection   : SortDirection.ASC,
        params          : {}
    },
    groupingType:       'single', // single or double grouping
    sortBy:             null,  // current sort by column value*/
    sorting                 : null,  // current sorting value
    grouping                : { // current grouping value
        mode    : GroupingType.CUSTOM,
        fields  : [{
            fieldId         : 'statusId',
            sortDirection   : SortDirection.ASC,
            params          : {}
        }]
    },
    filters:            {},

    areEmptyFoldersHidden   : false,
    areEmptyGroupsHidden    : true,
    areAddRowsHidden        : false,
    itemViewBorderPosition  : CardViewLayout.COLOR_CODING_NONE,
    colorTasksFieldId       : 'statusId',
    // background              : BackGround.WHITE,
    showSubTasks            : false,
}
